<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-gap-5">
  <div [matTooltip]="permissionLabel" matTooltipPosition="right">
    <mat-icon fontSet="mdi" [fontIcon]="permissionIcon"></mat-icon>
  </div>
  <div>
    <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="tooltip-icon"></mat-icon>
  </div>
</div>
